<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout align-start>
      <v-flex>
        <!-- Modal persona -->
        <v-dialog v-model="verPersona" max-width="700px" persistent>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>Nuevo Cliente</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="guardarPersona" :loading="desabilitarPer" :disabled="desabilitarPer || !isValidPer">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn icon @click="closePersona">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="isValidPer">
                <v-row class="mt-2">
                  <v-col cols="6" sm="3">
                    <v-select dense v-model="idtipo_documento_pers" :items="tipo_documentos_cli" label="Tipo Documento"
                      :rules="[v => !!v || 'Tipo documento requerido']" @change="num_documento = ''" hide-details>
                    </v-select>
                  </v-col>
                  <v-col cols="10" sm="5">
                    <v-text-field dense v-model.trim="num_documento" label="Numero Documento"
                      :rules="[v => !!v || 'Numero documento requerido', v => (idtipo_documento_pers == 1 ? v.length == 8 || 'Numero DNI' : v.length == 11 || 'Numero RUC')]"
                      :maxlength="idtipo_documento_pers == 1 ? 8 : 11"
                      :disabled="idtipo_documento_pers == 1 ? false : idtipo_documento_pers == 6 ? false : true"
                      @keypress="common.isNum($event)" hide-details></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="1">
                    <div class="text-center">
                      <v-btn x-small fab color="primary" class="hide-detailswhite--text" :loading="desabilitarBuscar"
                        :disabled="(idtipo_documento_pers == 1 && num_documento.length == 8 ? false : idtipo_documento_pers == 6 && num_documento.length == 11 ? false : true) || desabilitarBuscar"
                        @click="extraerDocumento()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="nombre"
                      :label="idtipo_documento_pers == 1 ? 'Apellidos y Nombres' : 'Nombre'"
                      :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 200) || 'Nombre debe tener entre 3 a 200 caracteres']"
                      maxlength="100" prepend-inner-icon="person" v-uppercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete dense @keyup="selectUbigeo()" :search-input.sync="buscar_ubigeo" v-model="idubigeo"
                      :items="ubigeos" label="Ubigeo" :rules="[v => !!v || 'Ubigeo requerido']"
                      prepend-inner-icon="pin_drop" clearable class="mr-1"></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="direccion" label="Direccion"
                      :rules="[v => v.length <= 200 || 'La dirección no debe tener mas de 200 caracteres']"
                      maxlength="200" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field dense v-model.trim="email" label="Email"
                      :rules="[v => v == '' ? !v : /.+@.+\..+/.test(v) || 'Ingrese un email valido', Rules.sinespacio]"
                      maxlength="60" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field dense v-model.trim="telefono" label="Telefono"
                      :rules="[v => v.length <= 30 || 'El Telefono no debe tener mas de 30 caracteres', Rules.unespacio]"
                      maxlength="30" prepend-inner-icon="phone" v-uppercase hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal persona -->

        <!-- Producto -->
        <v-dialog v-model="verProductos" max-width="1200px">
          <v-card>
            <v-toolbar dark dense class="primary mb-1" flat>
              <v-toolbar-title>Productos</v-toolbar-title>
              <v-row>
                <v-spacer />
                <v-col cols="5" md="3" sm="3">
                  <v-select dense solo-inverted v-model="vts.nombre" :items="vts.ventas" label="Precios" hide-details>
                  </v-select>
                </v-col>
                <v-spacer />
                <v-col cols="7" md="8" sm="8">
                  <v-text-field dense solo-inverted v-model.trim="brDescripcion" label="Buscar Productos"
                    prepend-inner-icon="search" clearable hide-details @keyup="listarProductoBuscar">
                  </v-text-field>
                </v-col>
                <v-spacer />
              </v-row>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="dpurple" @click="mostrarEstablecimientos()" v-on="on">
                    <v-icon>category</v-icon>
                  </v-btn>
                </template>
                <span>Buscar Stock Establecimientos</span>
              </v-tooltip>

              <v-btn icon @click="ocultarProductos()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <!-- Mostrar imagen de producto -->
              <v-dialog v-model="selectedZoom" max-width="350px">
                <v-avatar tile size="350">
                  <img :src="'data:image/png;base64,' + imagen_zoom" />
                </v-avatar>
              </v-dialog>
              <!-- Fin Mostrar imagen de producto -->
              <v-form v-model="isValidP">
                <v-data-table :headers="cabeceraBusquedaProductos" :items="productos" :items-per-page="15"
                  item-key="iddetalle_compra" show-expand class="elevation-3" @dblclick:row="dblClickRepuesto" dense>
                  <template v-slot:item.seleccionar="{ item }">
                    <v-icon @click="agregarDetalle(item)" color="primary" :disabled="!isValidP">control_point</v-icon>
                  </template>

                  <template v-slot:item.imagen="{ item }">
                    <template>
                      <v-avatar tile size="27">
                        <img :src="'data:image/png;base64,' + item.imagen" @click="verImagen(item)" />
                      </v-avatar>
                    </template>
                  </template>

                  <template v-slot:item.codigos="{ item }">
                    <strong class="primary--text">{{ item.codigo_producto }} </strong> <br /> {{ item.codigo_producto2
                    }}
                  </template>

                  <template v-slot:item.stock_actual="{ item }">
                    <strong>{{ item.stock_actual }}</strong>
                  </template>

                  <template v-slot:item.marca="{ item }">
                    <strong class="error--text">{{ item.marca }}</strong>
                  </template>

                  <template v-slot:item.precio_unit_venta="{ item }">
                    <div class="text-right">
                      <span>{{ item.precio_unit_venta | formatearNumero }}</span>
                    </div>
                  </template>

                  <template v-slot:item.precios_ventas="{ item }">
                    <div class="text-right">
                      <template v-if="vts.nombre == 'precio_unit_venta'">
                        <strong>{{ item.precio_unit_venta | formatearNumero }}</strong>
                      </template>

                      <template v-if="vts.nombre == 'precio_unit_cliente'">
                        <strong>{{ item.precio_unit_cliente | formatearNumero }}</strong>
                      </template>

                      <template v-if="vts.nombre == 'precio_unit_distribuidor'">
                        <strong>{{ item.precio_unit_distribuidor | formatearNumero }}</strong>
                      </template>
                    </div>
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-row class="mt-0 mb-0">
                        <v-col cols="6" md="9" sm="4">
                          <v-text-field dense type="text" label="Descripción"
                            :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 10 && v.length <= 240) || 'Nombre debe tener entre 10 a 240 caracteres', Rules.unespacio]"
                            v-model.trim="item.descripcion_adicional" maxlength="200" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3" sm="4">
                          <v-select dense v-model="item.idtipo_afectacion" :items="tipo_afectacion"
                            label="Tipo Afectación" hide-details></v-select>
                        </v-col>
                      </v-row>

                      <template v-if="item.serie" class="mr-2">
                        <strong>SERIE:</strong>
                        {{ item.serie }}
                      </template>

                      <template v-if="esAdministrador">
                        <strong>Precio Compra:</strong>
                        <span>{{ item.idtipo_servicio == 3 ? "S/" : "$" }}
                          {{ item.precio_unit_compra.toFixed(2) | formatearNumero }}</span>
                        <template v-if="item.idtipo_servicio == 4">
                          <strong class="ml-2" v-if="esAdministrador">Precio Compra TC:</strong>
                          <span v-if="esAdministrador">S/ {{ (item.idtipo_servicio == 3 ?
                            item.precio_unit_compra : item.precio_unit_compra *
                            tc).toFixed(2) | formatearNumero
                            }}</span>
                        </template>
                        <br />
                      </template>
                      <strong>PROVEEDOR:</strong>
                      {{ item.proveedor.substring(0, 30) }}
                      <strong class="ml-4">FEC.INGRESO:</strong>
                      {{ item.fecha | formatearFecha }}
                      <strong>Pedido:</strong>
                      {{ item.idpedido }}
                    </td>
                  </template>
                </v-data-table>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Producto -->

        <!--Modal sucursal stock -->
        <v-dialog v-model="verEstablecimientosProductos" max-width="800px" scrollable persistent>
          <v-card>
            <v-toolbar dark dense class="primary mb-1">
              <v-autocomplete dense solo-inverted @keyup="selectProductos()"
                @change="listarStockEstablecimiento(idproducto), changeProductos(idproducto)"
                :search-input.sync="buscar_producto" :items="totalProductos" v-model="idproducto"
                label="Buscar Producto" :rules="[v => !!v || 'El producto es requerido']" prepend-inner-icon="category"
                required hide-details clearable>
              </v-autocomplete>
              <v-btn icon @click="ocultarEstablecimientos()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-chip class="ma-1" label>
                Precio Unitario Venta: S/ {{ precioVenta | formatearNumero }}
              </v-chip>
              <v-chip class="ma-1" label>
                Cliente: S/ {{ precioCliente | formatearNumero }}
              </v-chip>
              <v-chip class="ma-1" label>
                Distribuidor: S/ {{ precioDistribuidor | formatearNumero }}
              </v-chip>
              <v-data-table :headers="cabeceraStockEstablecimiento" :items="stockEstablecimiento"
                class="elevation-3 ma-1" dense hide-default-footer>

                <template v-slot:item.stockactual="{ item }">
                  <template v-if="item.stockactual == stockMinimo">
                    <v-chip color="warning" small dark>{{ item.stockactual }}</v-chip>
                  </template>

                  <template v-else-if="item.stockactual > stockMinimo">
                    <v-chip color="success" small dark>{{ item.stockactual }}</v-chip>
                  </template>

                  <template v-else>
                    <v-chip color="error" small dark>{{ item.stockactual }}</v-chip>
                  </template>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal sucursal stock -->

        <!-- Listado Pedido Cliente -->
        <v-data-table :loading="loading" :headers="cabeceraListarPedido" :items="pedidos" :items-per-page="15" dense
          class="elevation-3" v-if="verNuevoPedido == 0">

          <template v-slot:top>
            <!-- Titulo y busqueda pedido cliente -->
            <v-toolbar flat v-if="verNuevoPedido == 0">
              <v-toolbar-title class="hidden-sm-and-down">PEDIDO y PROFORMA CLIENTES</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <v-spacer />
              <!-- Formulario busqueda de pedido -->
              <v-text-field dense class="mr-1" v-model.trim="buscar_pedido" label="Búsqueda" @keyup="listar" single-line
                hide-details></v-text-field>
              <v-spacer />
              <v-menu v-model="menuFecha" :close-on-content-click="!menuFecha" transition="scale-transition" offset-y
                min-width="290px" :close-on-click="dates.length == 2 ? true : false">
                <template v-slot:activator="{ on }">
                  <v-text-field dense v-model="dateRangeText" readonly v-on="on" hide-details append-icon="update"
                    @click:append="listar()" class="mr-1" style="max-width: 220px;"></v-text-field>
                </template>
                <v-date-picker v-model="dates" @input="dates.length == 2 ? menuFecha = false : menuFecha = true"
                  @change="listar()" range></v-date-picker>
              </v-menu>
              <v-spacer />
              <!-- Fin Formulario busqueda de pedido -->
              <v-btn @click="mostrarNuevoPedido" color="primary" class="hidden-sm-and-down" small outlined>Nuevo</v-btn>
              <v-btn @click="mostrarNuevoPedido" color="primary" class="hidden-md-and-up" fab x-small outlined>
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- Fin Titulo y busqueda pedido cliente -->
          </template>
          <!-- Opciones editar, eliminar pedido cliente y realizar venta -->

          <template v-slot:item.usuario="{ item }">
            <span>{{ (item.usuario).substr(0, 12) }}</span>
          </template>

          <template v-slot:item.cliente="{ item }">
            <span>{{ (item.cliente).substr(0, 20) }}</span>
          </template>

          <template v-slot:item.moneda="{ item }">
            <div class="text-right">
              <strong>{{ item.moneda == "S" ? "S/" : "$" }}</strong>
            </div>
          </template>

          <template v-slot:item.importe_total="{ item }">
            <div class="text-right">
              <strong>{{ item.importe_total | formatearNumero }}</strong>
            </div>
          </template>

          <template v-slot:item.fecha="{ item }">
            <span>{{ item.fecha | formatearFecha }}</span>
          </template>

          <template v-slot:item.estado="{ item }">
            <template v-if="item.estado == 'Pendiente'">
              <span class="orange--text">Pendiente</span>
            </template>

            <template v-else>
              <span class="success--text">{{ item.estado }}</span>
            </template>
          </template>

          <template v-slot:item.gratuito="{ item }">
            <div class="text-right">
              <span>{{ item.gratuito | formatearNumero }}</span>
            </div>
          </template>

          <template v-slot:item.opciones="{ item }">
            <template v-if="item.tipo_pedido == 'Pedido' && esAdministrador || esCaja">
              <v-btn small icon>
                <v-icon color="success" @click="irVentas(item)">shopping_cart</v-icon>
              </v-btn>
            </template>
            <v-btn small icon>
              <v-icon color="print" @click="mostrarComprobante(item)">print</v-icon>
            </v-btn>
            <v-btn small icon>
              <v-icon color="primary" @click="verDetallesPedidos(item)">edit</v-icon>
            </v-btn>

            <template v-if="item.estado == 'Pendiente'">
              <v-btn small icon>
                <v-icon color="error" @click="deleteItemPedido(item)">delete_forever</v-icon>
              </v-btn>
            </template>
          </template>
          <!-- Fin Opciones editar, eliminar pedido cliente y realizar venta -->
        </v-data-table>
        <!--Fin Listado Pedido Cliente -->

        <!-- Ventana crear y modificar pedido  -->
        <v-card v-if="verNuevoPedido == 1" class="elevation-3">
          <v-toolbar dark dense class="primary" flat>
            <v-toolbar-title>{{ formTitle }} {{ tipo_pedido }} Cliente</v-toolbar-title>
            <v-spacer />
            <v-text-field dense solo-inverted @keyup.enter="buscarCodigoBarra()" v-model="codigo_barra"
              label="Código Barra" maxlength="30" append-icon="qr_code_scanner" style="max-width: 220px;" hide-details>
            </v-text-field>
          </v-toolbar>
          <v-card-text grid-list-sm v-if="verNuevoPedido">
            <v-form v-model="isValid">
              <v-row>
                <v-col cols="12" md="2" sm="2">
                  <v-select dense v-model="tipo_pedido" :items="tipos_pedido" label="Tipo"
                    :rules="[v => !!v || 'Tipo requerido']" hide-details></v-select>
                </v-col>
                <v-col cols="6" md="2" sm="2">
                  <v-select dense v-model="idtipo_servicio" :items="tipo_servicios" label="Moneda"
                    :rules="[v => !!v || 'Servicio requerido']" @change="detalles = []" hide-details></v-select>
                </v-col>
                <v-col cols="10" md="7" sm="5">
                  <v-autocomplete dense @keyup="selectCliente()" :search-input.sync="buscar_cliente" v-model="idpersona"
                    :items="clientes" label="Cliente" :rules="[v => !!v || 'El cliente es requerido']" clearable
                    append-outer-icon="person_add" @click:append-outer="mostrarPersona" hide-details></v-autocomplete>
                </v-col>
                <v-col cols="2" md="1" sm="2">
                  <div class="text-center">
                    <v-btn @click="mostrarProductos()" x-small fab color="primary" outlined>
                      <v-icon>list</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-data-table :loading="loadingDetalles" :headers="cabeceraDetallesPedidos" :items="detalles"
                    disable-pagination hide-default-footer dense class="elevation-3">

                    <template v-slot:item.num="{ item }">
                      <td>{{ detalles.indexOf(item) + 1 }}</td>
                    </template>

                    <template v-slot:item.borrar="{ item }">
                      <v-icon small color="error" @click="eliminarItemDetallePedido(detalles, item)">delete_forever
                      </v-icon>
                    </template>

                    <template v-slot:item.stock_actual="{ item }">
                      <span class="font-weight-bold">{{ item.stock_actual }}</span>
                    </template>

                    <template v-slot:item.cantidad="{ item }">
                      <v-text-field dense type="text" @keyup.up="item.cantidad++" @keyup.down="item.cantidad--"
                        v-model="item.cantidad"
                        :rules="[v => (!!v && v > 0) || 'Requerido', item.stock_actual >= item.cantidad || 'Cantidad no puede ser > a stock']"
                        maxlength="6" hide-details class="center-input" @keypress="common.isNum($event)"
                        onClick="this.select()"></v-text-field>
                    </template>
                    <!-- <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && v > item.precio_unit_compra || 'Requerido']" maxlength="9" hide-details
                        @keypress="common.numDec($event, item.precio_unit_venta, 4)" onClick="this.select()">
                      </v-text-field>
                    </template> -->

                    <template v-slot:item.precio_unit_venta="{ item }">
                      <v-text-field dense type="text" v-model="item.precio_unit_venta"
                        :rules="[v => !!v && v > 0 || 'Requerido']" maxlength="9" hide-details
                        @keypress="common.numDec($event, item.precio_unit_venta, 4)"
                        onClick="this.select()"></v-text-field>
                    </template>
                    <!-- <template v-slot:item.descto_item="{ item }">
                    <v-text-field
                      dense
                      type="text"
                      v-model="item.descto_item"
                      maxlength="6"
                      hide-details
                      class="right-input"
                      @keypress="common.numDec($event, item.descto_item, 4)" onClick="this.select()"
                    ></v-text-field>
                    </template>-->

                    <template v-slot:item.subtotal="{ item }">
                      <div class="text-right">
                        <span>{{ (item.cantidad * item.precio_unit_venta - item.descto_item) | formatearNumero }}</span>
                      </div>
                    </template>
                  </v-data-table>
                  <v-container>
                    <v-row no-gutters align="end" justify="end">
                      <!-- <v-col cols="10" align="end">
                      <strong>Descuento Global (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        v-model="descto_global"
                        maxlength="7"
                        @keypress="common.numDec($event, descto_global, 2)" onClick="this.select()"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="10" align="end">
                      <strong>Descuento por Item (-) S/</strong>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        dense
                        disabled
                        v-model="descto_item_total=common.roundOut(common.valDec(calcularDescuentoItem),2).toFixed(2)"
                        class="right-input"
                        hide-details
                      ></v-text-field>
                      </v-col>-->
                      <v-col cols="10" align="end">
                        <strong>Gravada {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="subtotal_gravado = common.roundOut(common.valDec(importe_total) / (1 + igv), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>IGV {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="igv_gravado = common.roundOut(common.valDec(importe_total) - common.valDec(subtotal_gravado), 2).toFixed(2)"
                          class="right-input" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Importe Total {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="importe_total = common.roundOut(common.valDec(calcularTotal) - common.valDec(descto_global), 2).toFixed(2)"
                          :rules="[v => v > 0 || 'Importe mayor a cero']" class="right-input" hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="10" align="end">
                        <strong>Gratuita {{ idtipo_servicio == 5 ? "S/" : "$" }}</strong>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field dense disabled
                          v-model="gratuito = common.roundOut(calcularGratuitoTotal, 2).toFixed(2)" class="right-input"
                          hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="py-0 pb-4 px-4 justify-center">
            <v-btn color="error" @click="ocultarNuevo()" small outlined>
              <v-icon left>close</v-icon>Cancelar
            </v-btn>
            <v-btn color="primary" @click="guardarPedido()" :loading="desabilitar" :disabled="desabilitar || !isValid"
              small outlined>
              <v-icon left>check</v-icon>Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- Fin Ventana crear y modificar pedido  -->

        <!-- Modal impresión -->
        <v-dialog v-model="comprobanteModal" max-width="700px" scrollable>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>{{ tipo_pedido }} Cliente Nº {{ idpedido }}</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="printExternal()">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn icon @click="savePdf()">
                <v-icon>download</v-icon>
              </v-btn>
              <v-btn icon @click="ocultarComprobante()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 400px;" class="px-0">
              <pdf :src="stringPdf"></pdf>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal impresión -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import jsPDF from "jspdf";
import pdf from "vue-pdf";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      pedidos: [],

      detalles: [], // Detalles de pedido
      detalle_pedidos: [], // Detalles formateado

      cabeceraListarPedido: [
        { text: "CdPd", value: "idpedido", sortable: false },
        { text: "USUARIO", value: "usuario", sortable: false },
        { text: "CLIENTE", value: "cliente", sortable: false },
        { text: "TIPO", value: "tipo_pedido", sortable: false },
        { text: "M", value: "moneda", sortable: false },
        { text: "IMPORTE", value: "importe_total", sortable: false },
        { text: "GRATUITO", value: "gratuito", sortable: false },
        { text: "FECHA", value: "fecha", sortable: false },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "OPCIÓN", value: "opciones", sortable: false, width: 145 },
      ],

      cabeceraDetallesPedidos: [
        { text: "", value: "borrar", sortable: false },
        { text: "#", value: "num", sortable: false },
        //{ text: "CÓDIGO", value: "codigo_producto", sortable: false },
        { text: "DESCRIPCIÓN", value: "descripcion_adicional", sortable: false, },
        { text: "STOCK", value: "stock_actual", sortable: false },
        { text: "CANT.", value: "cantidad", align: "center", sortable: false },
        { text: "PRECIO", value: "precio_unit_venta", sortable: false },
        //{ text: "DSCTO", value: "descto_item", sortable: false },
        { text: "TOTAL", value: "subtotal", sortable: false },
      ],

      cabeceraBusquedaProductos: [
        { text: "...", value: "data-table-expand", align: "center" },
        { text: "+", value: "seleccionar", align: "center", sortable: false },
        { text: "IMG", value: "imagen", align: "center", sortable: false },
        { text: "U/M", value: "idunidad_medida", sortable: false },
        { text: "CÓDIGOS", value: "codigos", sortable: false },
        { text: "NOMBRE", value: "descripcion", sortable: false },
        { text: "CATEGORÍA", value: "categoria", sortable: false },
        { text: "MARCA", value: "marca", sortable: false, divider: true },
        { text: "STOCK", align: "center", value: "stock_actual", sortable: false, divider: true },
        { text: "PRECIO S/", value: "precios_ventas", sortable: false },
      ],

      cabeceraStockEstablecimiento: [
        { text: "CdEt", value: "idsucursal", align: "center", sortable: false },
        { text: "ESTABLECIMIENTOS", value: "establecimiento", sortable: false, divider: true },
        { text: "STOCK", value: "stockactual", align: "center", sortable: false },
      ],

      loading: false,
      loadingDetalles: false,

      buscar_pedido: "",
      buscar_cliente: "",
      buscar_ubigeo: "",
      codigo_barra: "",
      productos: [],

      brDescripcion: "",

      idpedido: "",
      idpersona: "",
      clientes: [],
      idtipo_servicio: 5, // Pedido S/
      tipo_servicios: [],

      igv: 0,
      tc: 0,
      placa: "",
      descto_global: 0,
      descto_item_total: 0,
      subtotal_gravado: 0,
      gratuito: 0,
      igv_gravado: 0,
      importe_total: 0,

      selectedZoom: false,
      imagen_zoom: "",

      verEstablecimientosProductos: 0,
      buscar_producto: "",
      idproducto: "",
      totalProductos: [],

      stockEstablecimiento: [],
      precioVenta: "",
      precioCliente: "",
      precioDistribuidor: "",
      stockMinimo: "",

      verNuevoPedido: 0,
      verProductos: 0,

      sucursal: "",
      cliente: "",
      fecha: "",
      num_documento: "",
      direccion: "",
      telefono: "",
      email: "",
      moneda: "",

      comprobanteModal: 0,

      fecha_vencimiento_formateada: "",
      fecha_vencimiento: new Date().toISOString().substr(0, 10),
      menuCalendario: false,

      desabilitar: false, // Desabilitamos boton guardar
      isValid: true, // validamos que todos lo campos sean correctos
      isValidP: true,

      // Persona
      nombre: "",
      idtipo_documento_pers: "",
      tipo_documentos_cli: [],
      num_documento: "",
      idubigeo: "", // select ubigeos
      ubigeos: [],
      direccion: "",
      telefono: "",
      email: "",
      verPersona: false,
      desabilitarBuscar: false,
      desabilitarPer: false,
      isValidPer: true,
      // Persona
      tipo_afectacion: [],

      dates: [
        moment().startOf("year").format("YYYY-MM-DD"),
        moment().endOf("year").format("YYYY-MM-DD"),
      ],
      menuFecha: false,

      vts: {
        nombre: "precio_unit_venta",
        ventas: [
          { text: "Venta", value: "precio_unit_venta" },
          { text: "Cliente", value: "precio_unit_cliente" },
          { text: "Distribuidor", value: "precio_unit_distribuidor" },
        ],
      },

      tipo_pedido: "Pedido",
      tipos_pedido: [
        { text: "Pedido", value: "Pedido" },
        { text: "Proforma", value: "Proforma" },
      ],

      stringPdf: "",
      blobPdf: "",

      editedIndex: -1,

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapState(["usuario", "datos", "logo"]),
    ...mapGetters(["esAdministrador", "esCaja"]),

    dateRangeText() {
      let fechaIni;
      let fechaFin;
      for (var i = 0; i < this.dates.length; i++) {
        fechaIni = this.common.formatDate(this.dates[0]);
        fechaFin = this.common.formatDate(this.dates[1]);
      }
      let arrayFechas = [fechaIni, fechaFin];
      return arrayFechas.join(" ~ ");
    },

    // Titulo de pedidos
    formTitle() {
      return this.editedIndex === -1 ? "" : "Actualizar";
    },

    calcularTotal: function () {
      let me = this;
      var resultado = 0.0;

      for (var i = 0; i < me.detalles.length; i++) {
        if (me.detalles[i].idtipo_afectacion == "10") {
          resultado = resultado + me.common.roundOut(me.common.valInt(me.detalles[i].cantidad) * me.common.valDec(me.detalles[i].precio_unit_venta) - me.common.valDec(me.detalles[i].descto_item), 2);
        }
      }
      return resultado;
    },

    calcularGratuitoTotal: function () {
      let me = this;
      var resultado = 0.0;
      for (var i = 0; i < me.detalles.length; i++) {
        if (me.detalles[i].idtipo_afectacion == "31") {
          resultado = resultado + me.common.roundOut(me.common.valInt(me.detalles[i].cantidad) * me.common.valDec(me.detalles[i].precio_unit_venta) - me.common.valDec(me.detalles[i].descto_item), 2);
        }
      }
      return resultado;
    },

    calcularDescuentoItem: function () {
      let me = this;
      var resultado = 0.0;
      for (var i = 0; i < me.detalles.length; i++) {
        resultado = resultado + me.common.roundOut(me.common.valDec(me.detalles[i].descto_item), 2);
      }
      return resultado;
    },
  },

  watch: {
    comprobanteModal(val) {
      val || this.ocultarComprobante();
    },
    verProductos(val) {
      val || this.ocultarProductos();
    },
    brDescripcion(newVal) {
      if (newVal === null) {
        this.brDescripcion = "";
      }
    },
  },

  created() {
    this.igv = parseFloat(this.datos.igv);
    this.tc = parseFloat(this.datos.tc);

    this.listar();
    this.select();
  },

  methods: {
    ...mapActions(["snackBar"]),

    //#region LISTAR PEDIDOS
    listar() {
      let me = this;
      me.loading = true;

      axios.get("api/Pedidos/ListarFiltroPedidoVentas", {
        params: {
          idsucursal: parseInt(me.usuario.idsucursal),
          buscar: me.buscar_pedido == "" ? "-" : me.buscar_pedido,
          fechaInicio: me.dates[0],
          fechaFin:
            me.dates[1] == undefined
              ? me.dates[0] + " 23:59:59"
              : me.dates[1] + " 23:59:59",
        },
      })
        .then(function (response) {
          me.pedidos = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion

    irVentas(item) {
      this.$router.push({
        name: "ventas",
        params: {
          depedido: true,
          deidtipo_servicio: item.idtipo_servicio,
          deidpersona: item.idpersona,
          deidpedido: item.idpedido,
        },
      });
    },

    //#region SELECT
    selectCliente(id) {
      let me = this;

      var clientesArray = [];

      if (id) {
        axios.get("api/Personas/SelectPersonas/" + id)
          .then(function (response) {
            clientesArray = response.data;
            clientesArray.map(function (x) {
              me.clientes.push({
                text: x.num_documento + " " + x.nombre + " |" + x.distrito + " - " + x.direccion,
                value: x.idpersona,
                tipo_documento: x.idtipo_documento,
              });
            });
          })

          .catch(function (error) {
            //console.log(error);
          });
      } else {
        axios.get("api/Personas/SelectPersonasFiltro", {
          params: {
            buscar:
              me.buscar_cliente == ""
                ? "-"
                : me.buscar_cliente == null
                  ? "-"
                  : me.buscar_cliente,
            tipo_doc: "-",
          },
        })
          .then(function (response) {
            clientesArray = response.data;
            clientesArray.map(function (x) {
              me.clientes.push({
                text: x.num_documento + " " + x.nombre + " |" + x.distrito + " - " + x.direccion,
                value: x.idpersona,
                tipo_documento: x.idtipo_documento,
              });
            });
          })

          .catch(function (error) {
            //console.log(error);
          });
      }
    },

    selectUbigeo(id) {
      let me = this;

      var ubigeosArray = [];

      if (id) {
        axios.get("api/Ubigeos/SelectUbigeos/" + id)
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        axios.get("api/Ubigeos/SelectUbigeosFiltro", {
          params: {
            buscar:
              me.buscar_ubigeo == ""
                ? "-"
                : me.buscar_ubigeo == null
                  ? "-"
                  : me.buscar_ubigeo,
          },
        })
          .then(function (response) {
            ubigeosArray = response.data;
            ubigeosArray.map(function (x) {
              me.ubigeos.push({
                text: x.depprovdist,
                value: x.idubigeo,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      }
    },

    select() {
      let me = this;

      var tipo_serviciosArray = [];
      axios.get("api/Tipo_Servicios/SelectMonVenta")
        .then(function (response) {
          tipo_serviciosArray = response.data;
          tipo_serviciosArray.map(function (x) {
            me.tipo_servicios.push({
              text: x.nombre,
              value: x.idtipo_servicio,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
      var tipo_documentosArray = [];
      axios.get("api/Tipo_Documentos/Select")
        .then(function (response) {
          tipo_documentosArray = response.data;
          tipo_documentosArray.map(function (x) {
            me.tipo_documentos_cli.push({
              text: x.descripcion,
              value: x.idtipo_documento,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_afectacionArray = [];
      axios.get("api/Tipo_Afectacion/Select")
        .then(function (response) {
          tipo_afectacionArray = response.data;
          tipo_afectacionArray.map(function (x) {
            me.tipo_afectacion.push({
              text: x.descripcion,
              value: x.idtipo_afectacion,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion SELECT

    //#region PEDIDO
    guardarPedido() {
      let me = this;
      // Validamos detalle
      if (me.detalles.length <= 0) {
        return me.snackBar({ cl: "warning", msg: "Ingrese al menos un producto al detalle." });
      }
      if (me.detalles.length > 30) {
        return me.snackBar({ cl: "warning", msg: "El detalle solo acepta hasta 30 items." });
      }

      me.desabilitar = true;
      me.detalle_pedidos = [];
      me.convertirDetalle();

      if (me.editedIndex > -1) {
        // Editar
        axios.put("api/Pedidos/ActualizarPedidoCliente", {
          idpedido: me.idpedido,
          idsucursal: parseInt(me.usuario.idsucursal),
          idpersona: me.idpersona,
          idtipo_servicio: me.idtipo_servicio,
          idusuario: parseInt(me.usuario.idusuario),
          tipo_pedido: me.tipo_pedido,
          descto_global: 0,
          descto_item_total: 0,
          otros_item_total: 0,
          seguro: 0,
          inafecto: 0,
          exonerado: 0,
          subtotal_gravado: parseFloat(me.subtotal_gravado),
          gratuito: parseFloat(me.gratuito),
          igv_gravado: parseFloat(me.igv_gravado),
          importe_total: parseFloat(me.importe_total),
          igv: me.igv,
          detalle_pedidos: me.detalle_pedidos,
        })
          .then(function (response) {
            me.snackBar({ cl: "success", msg: response.data });
            me.ocultarNuevo();
            me.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else {
        // Guardar
        axios.post("api/Pedidos/CrearPedidoCliente", {
          idsucursal: parseInt(me.usuario.idsucursal),
          idpersona: me.idpersona,
          idtipo_servicio: me.idtipo_servicio,
          idusuario: parseInt(me.usuario.idusuario),
          tipo_pedido: me.tipo_pedido,
          descto_global: 0,
          descto_item_total: 0,
          otros_item_total: 0,
          seguro: 0,
          inafecto: 0,
          exonerado: 0,
          subtotal_gravado: parseFloat(me.subtotal_gravado),
          gratuito: parseFloat(me.gratuito),
          igv_gravado: parseFloat(me.igv_gravado),
          importe_total: parseFloat(me.importe_total),
          igv: me.igv,
          detalle_pedidos: me.detalle_pedidos,
        })
          .then(function (response) {
            me.snackBar({ cl: "success", msg: response.data });
            me.ocultarNuevo();
            me.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      }
    },

    convertirDetalle() {
      let me = this;
      for (var i = 0; i < me.detalles.length; i++) {
        me.detalle_pedidos.push({
          idproducto: me.detalles[i].idproducto,
          iddetalle_compra: me.detalles[i].iddetalle_compra,
          idunidad_medida: me.detalles[i].idunidad_medida,
          cantidad: parseInt(me.detalles[i].cantidad),
          valor_unit_venta: me.common.roundOut(parseFloat(me.detalles[i].precio_unit_venta) / (1 + me.igv), 4),
          precio_unit_venta: parseFloat(me.detalles[i].precio_unit_venta),
          descto_item: me.common.valDec(me.detalles[i].descto_item),
          valor_venta: me.common.roundOut((parseInt(me.detalles[i].cantidad) * parseFloat(me.detalles[i].precio_unit_venta)) / (1 + me.igv), 2),
          precio_venta: me.common.roundOut(parseInt(me.detalles[i].cantidad) * parseFloat(me.detalles[i].precio_unit_venta), 2),
          igv: me.igv * 100, // FE 18%
          codigo_producto: me.detalles[i].codigo_producto, // FE
          descripcion_adicional: me.detalles[i].descripcion_adicional,
          idprod_sunat: me.detalles[i].idprod_sunat, // FE
          idtipo_afectacion: me.detalles[i].idtipo_afectacion,
        });
      }
    },

    mostrarNuevoPedido() {
      this.verNuevoPedido = 1;
    },

    deleteItemPedido(item) {
      const respta = confirm(
        "¿Estás seguro de Eliminar el pedido Nº " + item.idpedido + " ?"
      );
      let me = this;

      if (respta) {
        axios.delete("api/Pedidos/Eliminar/" + item.idpedido)
          .then((response) => {
            me.snackBar({ cl: "info", msg: response.data });
            me.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
          });
      }
    },

    eliminarItemDetallePedido(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    ocultarNuevo() {
      this.verNuevoPedido = 0;
      this.desabilitar = false;
      this.listar();
      this.limpiar();
    },
    //#endregion PEDIDO

    //#region IMPRESIÓN
    savePdf() {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(this.blobPdf);
      var fileName =
        this.tipo_pedido == "Pedido"
          ? "Pedido Cliente Nro" + this.idpedido
          : "Proforma Venta Nro" + this.idpedido;
      link.download = fileName;
      link.click();
    },

    printExternal() {
      printJS({
        printable: this.stringPdf.replace(
          "data:application/pdf;filename=generated.pdf;base64,",
          ""
        ),
        type: "pdf",
        base64: true,
      });
    },

    mostrarComprobante(item) {
      this.limpiar();
      this.idpedido = item.idpedido;
      this.tipo_pedido = item.tipo_pedido;
      this.idtipo_servicio = item.idtipo_servicio;
      this.sucursal = item.sucursal;
      this.cliente = item.cliente;
      this.num_documento = item.num_documento;
      this.fecha = item.fecha;
      this.igv = item.igv;
      this.moneda = item.moneda;
      this.idpedido = item.idpedido;
      this.subtotal_gravado = item.subtotal_gravado;
      this.gratuito = item.gratuito;
      this.igv_gravado = item.igv_gravado;
      this.importe_total = item.importe_total;
      this.comprobanteModal = 1;
      //this.listarDetallePedidos(item.idpedido);
      this.listarDetallePedidosImp(item.idpedido);
    },

    verImagen(item) {
      this.imagen_zoom = item.imagen;
      this.selectedZoom = true;
    },
    ocultarComprobante() {
      this.comprobanteModal = 0;
      this.limpiar();
    },
    //#endregion IMPRESIÓN

    //#region DETALLES DE PEDIDOS
    // Ver pedido con detalles para modificar
    verDetallesPedidos(item) {
      this.limpiar();
      this.idpedido = item.idpedido;
      this.tipo_pedido = item.tipo_pedido;
      this.idtipo_servicio = item.idtipo_servicio;
      this.idpersona = item.idpersona;
      this.selectCliente(item.idpersona);
      this.listarDetallePedidos(item.idpedido);
      this.verNuevoPedido = 1;
      this.editedIndex = 1;
    },

    listarDetallePedidos(id) {
      let me = this;
      var detallesArray = [];
      me.loadingDetalles = true;

      axios.get("api/Pedidos/ListarDetallesPedidos/" + id)
        .then(function (response) {
          detallesArray = response.data;
          detallesArray.map(function (x) {
            me.detalles.push({
              idproducto: x.idproducto,
              codigo_producto: x.codigo_producto, // FE
              //categoria: x.categoria,
              //marca: x.marca,
              descripcion_adicional: x.descripcion_adicional,
              stock_actual: x.stock_actual,
              iddetalle_compra: x.iddetalle_compra,
              idunidad_medida: x.idunidad_medida,
              cantidad: x.cantidad,
              valor_unit_venta: x.valor_unit_venta,
              precio_unit_venta: x.precio_unit_venta,
              descto_item: x.descto_item,
              valor_venta: x.valor_venta,
              precio_venta: x.precio_venta,
              idprod_sunat: x.idprod_sunat,
              idtipo_afectacion: x.idtipo_afectacion,
              precio_unit_compra: me.common.roundOut((x.idtipo_servicio == 3 ? x.precio_unit_compra : x.precio_unit_compra * me.tc), 2) // > compra
            });
          });
          me.loadingDetalles = false;
          me.comprobanteModal == 1 ? me.crearPDF() : ""; // Solo para pedido pdf
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    listarDetallePedidosImp(id) {
      let me = this;
      var detallesArray = [];

      axios.get("api/Pedidos/ListarImpDetallesPedidos/" + id)
        .then(function (response) {
          detallesArray = response.data; // recorremos el array de detallesArray de ventas para formatear el precio_unit_venta
          detallesArray.map(function (x) {
            me.detalles.push({
              idproducto: x.idproducto,
              serie: x.serie,
              cantidad: x.cantidad,
              idunidad_medida: x.idunidad_medida,
              descripcion_adicional: x.descripcion_adicional,
              precio_unit_venta: x.precio_unit_venta,
              precio_venta: x.precio_venta,
            });
          });
          me.comprobanteModal == 1 ? me.crearPDF() : ""; // Solo para pedido pdf
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion  FIN DETALLES DE PEDIDOS

    //#region PRODUCTO
    buscarCodigoBarra() {
      let me = this;

      axios.get("api/Pedidos/BuscarCodigoBarraVenta/" + parseInt(me.usuario.idsucursal) + "/" + me.codigo_barra)
        .then(function (response) {
          //console.log(response.data);
          me.agregarDetalle(response.data);
          me.snackBar({ cl: "info", msg: "Se agrego " + response.data.descripcion + " al detalle." });
          me.codigo_barra = "";
        })
        .catch(function (error) {
          //console.log(error);
          me.snackBar({ cl: "warning", msg: "No hay registro de compra para el producto." });
          me.codigo_barra = "";
        });
    },

    listarProductoBuscar() {
      let me = this;

      axios.get("api/Pedidos/ListarProductoVenta", {
        params: {
          idsucursal: parseInt(me.usuario.idsucursal),
          descripcion: me.brDescripcion == "" ? "-" : me.brDescripcion,
        },
      })
        .then(function (response) {
          me.productos = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    dblClickRepuesto(event, { item }) {
      this.agregarDetalle(item);
    },

    agregarDetalle(data = []) {
      let me = this;
      // Buscar el índice del detalle existente con el mismo iddetalle_compra
      const indiceExistente = me.detalles.findIndex(detalle => detalle.iddetalle_compra === data["iddetalle_compra"]);

      if (indiceExistente !== -1) {
        // Si el detalle ya existe, sumar la cantidad
        me.detalles[indiceExistente].cantidad += 1;
      } else {
        me.detalles.push({
          idproducto: data["idproducto"],
          iddetalle_compra: data["iddetalle_compra"],
          codigo_producto: data["codigo_producto"], // FE
          //categoria: data["categoria"],
          //marca: data["marca"],
          idtipo_afectacion: data["idtipo_afectacion"],
          descripcion_adicional: data["descripcion_adicional"],
          stock_actual: data["stock_actual"],
          idunidad_medida: data["idunidad_medida"],
          cantidad: 1,
          valor_unit_venta: 0,
          precio_unit_venta: me.idtipo_servicio == 5 ? me.common.roundOut(data[me.vts.nombre], 2) : me.common.roundOut((data[me.vts.nombre] / me.tc), 2), // Capturamos el precio seleccionado

          descto_item: 0,
          valor_venta: 0,
          precio_venta: 0,
          idprod_sunat: data["idprod_sunat"],
          precio_unit_compra: me.common.roundOut((data["idtipo_servicio"] == 3 ? data["precio_unit_compra"] : data["precio_unit_compra"] * me.tc), 2) // > compra
        });
      }
    },

    mostrarProductos() {
      this.verProductos = 1;
    },

    ocultarProductos() {
      this.verProductos = 0;
      this.productos = [];
      this.imagen_zoom = "";
      this.brDescripcion = "";
      // limpiamos variables de buscar producto en establecimientos
      this.idproducto = "";
      this.buscar_producto = "";
      this.precioVenta = 0;
      this.precioCliente = 0;
      this.precioDistribuidor = 0;
      //this.totalProductos = [];
      this.stockEstablecimiento = [];
      this.stockMinimo = 1;
    },


    changeProductos(valor) {
      this.precioVenta = 0;
      this.precioCliente = 0;
      this.precioDistribuidor = 0;
      this.stockMinimo = 1;

      if (valor != null) {
        const selectId = this.totalProductos.find(
          (elemento) => elemento.value === valor
        );
        this.precioVenta = selectId.precioVenta;
        this.precioCliente = selectId.precioCliente;
        this.precioDistribuidor = selectId.precioDistribuidor;
        this.stockMinimo = selectId.stockMinimo;
      }
    },

    // Buscar productos
    selectProductos() {
      let me = this;
      var productosArray = []; // Limpiamos para cargar nuevamente

      axios.get("api/Productos/SelectBuscar", {
        params: {
          buscar: me.buscar_producto == "" ? "-" : me.buscar_producto == null ? "-" : me.buscar_producto
        },
      })
        .then(function (response) {
          productosArray = response.data;
          productosArray.map(function (x) {
            me.totalProductos.push({ text: x.codigo_producto + " " + x.descripcion + " " + x.categoria + " " + x.marca, value: x.idproducto, precioVenta: x.precio_unit_venta, precioCliente: x.precio_unit_cliente, precioDistribuidor: x.precio_unit_distribuidor, stockMinimo: x.stock_minimo });
          });
        })
        .then((data) => { })
        .catch(function (error) {
          //console.log(error);
        });

    },

    listarStockEstablecimiento(id) {
      let me = this;

      axios.get("api/Productos/ListarStockEstablecimiento", {
        params: {
          idproducto: id
        },
      })
        .then(function (response) {
          me.stockEstablecimiento = response.data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    mostrarEstablecimientos() {
      this.verEstablecimientosProductos = 1;
    },
    ocultarEstablecimientos() {
      this.verEstablecimientosProductos = 0;
    },
    //#endregion FIN PRODUCTO

    //#region PERSONA
    extraerDocumento() {
      let me = this;
      me.desabilitarBuscar = true;

      var token =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImpmcmFpbkBob3RtYWlsLmVzIn0.tT4tLoVKqPHNbwZsFbim_mUkJkz5zZtseefC0s7RBFs";
      if (me.idtipo_documento_pers == 1) {
        fetch(
          "https://dniruc.apisperu.com/api/v1/dni/" +
          me.num_documento +
          "?token=" +
          token
        )
          .then((response) => response.json())
          .then(function (data) {
            me.desabilitarBuscar = false;
            if (data.message == undefined) {
              me.idubigeo = "000000";
              me.selectUbigeo(me.idubigeo);
              me.direccion = "";
              me.nombre = data.apellidoPaterno + " " + data.apellidoMaterno + " " + data.nombres;
            } else {
              me.nombre = "";
              me.direccion = "";
              me.snackBar({ cl: "info", msg: data.message }); // Sin resultados
            }
          })
          .catch(function () {
            me.desabilitarBuscar = false;
            me.idubigeo = "";
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: "Error en el Nº DNI." });
          });
        // if (me.idtipo_documento_pers == 1) {
        //   axios.get("api/Personas/ConsultarDni", {
        //     params: {
        //       nrodoc: me.num_documento,
        //     },
        //   })
        //     .then(function (response) {
        //       //console.log(response.data)
        //       me.desabilitarBuscar = false;
        //       if (response.data.exito == true) {
        //         me.nombre = response.data.apellidoPaterno + " " + response.data.apellidoMaterno + " " + response.data.nombres;
        //         me.idubigeo = "000000";
        //         me.selectUbigeo(me.idubigeo);
        //         me.direccion = "";
        //         me.snackBar({ cl: "success", msg: response.data.mensaje });
        //       } else {
        //         me.idubigeo = "";
        //         me.nombre = "";
        //         me.direccion = "";
        //         me.snackBar({ cl: "error", msg: response.data.mensaje });
        //       }
        //     })
        //     .catch((err) => {
        //       me.desabilitarBuscar = false;
        //       me.idubigeo = "";
        //       me.nombre = "";
        //       me.direccion = "";
        //       me.snackBar({ cl: "error", msg: "Hubo un error" });
        //     });
      } else if (me.idtipo_documento_pers == 6) {
        axios.post("api/Personas/Padron", {
          ruc: me.num_documento,
        })
          .then(function (response) {
            me.desabilitarBuscar = false;
            me.idubigeo = response.data.ubigeo;
            me.selectUbigeo(me.idubigeo);
            me.nombre = response.data.razon;
            me.direccion =
              response.data.direccion == null
                ? ""
                : response.data.direccion.trim();
            me.snackBar({ cl: "info", msg: "Contribuyente con estado " + response.data.estado + " y condición " + response.data.condicion });
          })
          .catch(function (error) {
            me.desabilitarBuscar = false;
            me.nombre = "";
            me.direccion = "";
            me.snackBar({ cl: "error", msg: error.response.data });
          });
      }
    },

    guardarPersona() {
      let me = this;
      me.desabilitarPer = true;

      //Código para guardar
      axios.post("api/Personas/Crear", {
        tipo_persona: "Cliente",
        nombre: me.nombre,
        idtipo_documento: me.idtipo_documento_pers,
        num_documento: me.num_documento,
        idubigeo: me.idubigeo,
        direccion: me.direccion,
        telefono: me.telefono,
        email: me.email,
      })
        .then((response) => {
          me.idpersona = response.data.idpersona;
          me.selectCliente(me.idpersona);
          me.desabilitarPer = false;
          me.snackBar({ cl: "success", msg: response.data.mensaje });
          me.closePersona();
        })
        .catch(function (error) {
          me.desabilitarPer = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    mostrarPersona() {
      this.verPersona = true;
    },

    closePersona() {
      this.verPersona = false;
      this.limpiarPersona();
    },

    limpiarPersona() {
      this.idtipo_documento_pers = "";
      this.num_documento = "";
      this.idubigeo = "";
      this.ubigeos = [];
      this.nombre = "";
      this.direccion = "";
      this.email = "";
      this.telefono = "";
    },
    //#endregion PERSONA

    limpiar() {
      this.igv = parseFloat(this.datos.igv); // Requerido

      this.idpedido = "";
      this.idtipo_servicio = 5; // Pedido Soles
      this.idpersona = "";
      this.num_documento = "";
      this.tipo_pedido = "Pedido";

      this.subtotal_gravado = 0;
      this.gratuito = 0;
      this.igv_gravado = 0;
      this.importe_total = 0;

      this.detalles = [];
      this.detalle_pedidos = [];
      this.clientes = [];
      this.moneda = "";

      this.codigo_barra = "";

      this.stringPdf = "";
      this.blobPdf = "";

      this.editedIndex = -1;
    },

    crearPDF() {
      var columns = [
        { header: "CANT.", dataKey: "cantidad" },
        { header: "U/M", dataKey: "idunidad_medida" },
        { header: "DESCRIPCIÓN", dataKey: "descripcion_adicional" },
        { header: "P.UNITARIO", dataKey: "precio_unit_venta" },
        { header: "TOTAL", dataKey: "subtotal" },
      ];
      var body = [];
      var foot = [];

      if (this.tipo_pedido == "Pedido") {
        for (var i = 0; i < this.detalles.length; i++) {
          body.push({
            cantidad: this.detalles[i].cantidad,
            idunidad_medida: this.detalles[i].idunidad_medida,
            descripcion_adicional: this.detalles[i].descripcion_adicional,
            precio_unit_venta: numeral(this.detalles[i].precio_unit_venta).format("###,##0.00"),
            subtotal: numeral(this.detalles[i].precio_venta).format("###,##0.00"),
          });

          if (i === this.detalles.length - 1) {
            foot.push(
              // [
              //   {
              //     content: "Gravada " + (this.moneda == "S" ? "S/" : "$"),
              //     colSpan: 4,
              //   },
              //   numeral(this.subtotal_gravado).format("###,##0.00"),
              // ],
              // [
              //   {
              //     content: "IGV " + (this.moneda == "S" ? "S/" : "$"),
              //     colSpan: 4,
              //   },
              //   numeral(this.igv_gravado).format("###,##0.00"),
              // ],
              [
                {
                  content: "Importe Total " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.importe_total).format("###,##0.00"),
              ],
              /* [
                {
                  content: "Importe Total $",
                  colSpan: 4,
                },
                numeral(this.common.roundOut(this.importe_total / this.tc, 2)).format("###,##0.00"),
              ], */
              [
                {
                  content: "Gratuita " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.gratuito).format("###,##0.00"),
              ]
            );
          }
        }

        // Titulo y logo
        const addHeaders = (doc) => {
          const pageCount = doc.internal.getNumberOfPages();

          for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.addImage(imgData, "JPEG", 40, 17, 70, 49.39);
            // Datos empresa
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(this.datos.empresa, 140, 28);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.text(this.datos.dirsucursal, 140, 38);
            doc.text("Telf.: " + this.datos.telsucursal, 140, 48);
            doc.text("E-Mail: " + this.datos.mailsucursal, 140, 58);
            // Fin Datos empresa

            // Datos cliente
            doc.text("Cliente: " + this.cliente, 40, 75);
            doc.text("Doc. N°: " + this.num_documento, 40, 90);

            doc.text("Establecimiento: " + this.sucursal, 360, 75);
            doc.text("Fecha: " + moment(this.fecha).format("DD/MM/YYYY"), 360, 90);
            // Fin Datos cliente

            // Datos documento
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);

            doc.text("PEDIDO CLIENTE", doc.internal.pageSize.width / 2 + 140, 42, "center");

            doc.text("N°" + this.idpedido, doc.internal.pageSize.width / 2 + 140, 54, "center");
            // Fin Datos documento
          }
        };
        // Pie de pagina
        // const addFooters = (doc) => {
        //   const pageCount = doc.internal.getNumberOfPages();

        //   doc.setFont("helvetica", "italic");
        //   doc.setFontSize(7);
        //   for (var i = 1; i <= pageCount; i++) {
        //     doc.setPage(i);
        //     doc.text(
        //       "Pagina " + String(i) + " de " + String(pageCount),
        //       doc.internal.pageSize.width / 2,
        //       820,
        //       "center"
        //     );
        //   }
        // };

        var imgData = "data:image/png;base64," + this.logo;
        var doc = new jsPDF("p", "pt", [595, 842]);

        doc.autoTable({
          //theme: "striped",
          columns,
          body,
          foot,
          margin: { top: 100 },
          //styles: { overflow: "ellipsize", cellWidth: "wrap" },
          headStyles: {
            fillColor: [46, 78, 121],
            fontSize: 7,
            halign: "center",
          },
          bodyStyles: { textColor: 0, fontSize: 8 },
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            fontSize: 8,
            halign: "right",
          },
          columnStyles: {
            cantidad: { cellWidth: 32, halign: "center" },
            idunidad_medida: { cellWidth: 40, halign: "center" },
            descripcion_adicional: { cellWidth: "auto" },
            precio_unit_venta: { cellWidth: 50, halign: "right" },
            subtotal: { cellWidth: 50, halign: "right" },
          },
        });

        doc.setProperties({
          title: "Pedido Cliente Nro" + this.idpedido + ".pdf",
        });
        addHeaders(doc);
        //addFooters(doc);
        //doc.save("PedidoClienteNro" + this.idpedido + ".pdf");
        this.stringPdf = doc.output("datauristring");
        this.blobPdf = doc.output("blob");
      } else {
        for (var i = 0; i < this.detalles.length; i++) {
          body.push({
            cantidad: this.detalles[i].cantidad,
            idunidad_medida: this.detalles[i].idunidad_medida,
            descripcion_adicional: this.detalles[i].descripcion_adicional,
            precio_unit_venta: numeral(this.detalles[i].precio_unit_venta).format("###,##0.00"),
            subtotal: numeral(this.detalles[i].precio_venta).format("###,##0.00"),
          });

          if (i === this.detalles.length - 1) {
            foot.push(
              [
                {
                  content: "Importe Total " + (this.moneda == "S" ? "S/" : "$"),
                  colSpan: 4,
                },
                numeral(this.importe_total).format("###,##0.00"),
              ],
              /* [
                {
                  content: "Importe Total $",
                  colSpan: 4,
                },
                numeral(this.common.roundOut(this.importe_total / this.tc, 2)).format("###,##0.00"),
              ] */
              /* [
                {
                  content: "Gratuita S/ ",
                  colSpan: 4,
                },
                numeral(this.gratuito).format("###,##0.00"),
              ] */
            );
          }
        }

        // Titulo y logo
        const addHeaders = (doc) => {
          const pageCount = doc.internal.getNumberOfPages();

          for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.addImage(imgData, "JPEG", 40, 17, 70, 49.39);
            doc.addImage(img1, "JPEG", 70, 725, 90, 90);
            doc.addImage(img2, "JPEG", 240, 740, 100, 76.67);
            doc.addImage(img3, "JPEG", 420, 740, 70, 70);
            // Datos empresa
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(this.datos.empresa, 140, 28);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.text(this.datos.dirsucursal, 140, 38);
            doc.text("Telf.: " + this.datos.telsucursal, 140, 48);
            doc.text("E-Mail: " + this.datos.mailsucursal, 140, 58);
            // Fin Datos empresa

            // Datos cliente
            doc.text("Cliente: " + this.cliente, 40, 75);
            doc.text("Doc. N°: " + this.num_documento, 40, 90);

            doc.text("Establecimiento: " + this.sucursal, 360, 75);
            doc.text(
              "Fecha: " + moment(this.fecha).format("DD/MM/YYYY"),
              360,
              90
            );
            // Fin Datos cliente

            // Datos documento
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);

            doc.text(
              "PROFORMA DE VENTA",
              doc.internal.pageSize.width / 2 + 140,
              42,
              "center"
            );

            doc.text(
              "N°" + this.idpedido,
              doc.internal.pageSize.width / 2 + 140,
              54,
              "center"
            );
            // Fin Datos documento
          }
        };
        // Pie de pagina
        // const addFooters = (doc) => {
        //   const pageCount = doc.internal.getNumberOfPages();

        //   doc.setFont("helvetica", "italic");
        //   doc.setFontSize(7);
        //   for (var i = 1; i <= pageCount; i++) {
        //     doc.setPage(i);
        //     doc.text(
        //       "Pagina " + String(i) + " de " + String(pageCount),
        //       doc.internal.pageSize.width / 2,
        //       820,
        //       "center"
        //     );
        //   }
        // };

        var imgData = "data:image/png;base64," + this.logo;
        var doc = new jsPDF("p", "pt", [595, 842]);
        var img1 =
          "data:image/png;base64,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"
        var img2 =
          "data:image/png;base64,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"
        var img3 =
          "data:image/png;base64,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"

        doc.autoTable({
          //theme: "striped",
          columns,
          body,
          foot,
          margin: { top: 100 },
          //styles: { overflow: "ellipsize", cellWidth: "wrap" },
          headStyles: {
            fillColor: [46, 78, 121],
            fontSize: 7,
            halign: "center",
          },
          bodyStyles: { textColor: 0, fontSize: 8 },
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            fontSize: 8,
            halign: "right",
          },
          columnStyles: {
            cantidad: { cellWidth: 32, halign: "center" },
            idunidad_medida: { cellWidth: 40, halign: "center" },
            descripcion_adicional: { cellWidth: "auto" },
            precio_unit_venta: { cellWidth: 50, halign: "right" },
            subtotal: { cellWidth: 50, halign: "right" },
          },
        });

        doc.setProperties({
          title: "Proforma Venta Nro" + this.idpedido + ".pdf",
        });
        addHeaders(doc);
        //addFooters(doc);
        //doc.save("ProformaVentaNro" + this.idpedido + ".pdf");
        this.stringPdf = doc.output("datauristring");
        this.blobPdf = doc.output("blob");
      }
    },
  },
};
</script>

<style scoped>
.right-input>>>input {
  text-align: right;
}

.center-input>>>input {
  text-align: center;
}
</style>